import './ReactPSUTeaser.scss'

import { ButtonTypes } from '@cox/core-ui8/dist/Button'

import { Placeholder } from '../../shared/ReactBootstrap'

const ReactPSUTeaserSkeleton = () => {
  // const { bulletPoints = { value: [] } } = elements
  return (
    <div data-testid={`react-product-teaser-card`} className='react-product-teaser-card'>
      <Placeholder as={'span'} style={{ height: '20px', width: '100px', backgroundColor: 'grey', borderRadius: '20px' }} />
      <div className='large-product-icon skeleton-img-placeholder' />
      <div className='icon-details'>
        <div className='skeleton-img-placeholder' style={{ height: '25px', width: '60px', borderRadius: '50%' }} />
        <Placeholder className='icon-description' xs={7} />
      </div>
      <div className='react-product-teaser-card-body'>
        <div className='plan-heading'>
          <Placeholder className='heading' xs={7} />
          <Placeholder className='additional-note' xs={7} />
        </div>
        <div className='details-container'>
          <Placeholder className='heading-description' xs={7} />
        </div>
        <div className='price-details'>
          <Placeholder className='plan-name' xs={7} />
          <Placeholder xs={7} />
        </div>
        <div className='product-teaser-buttons'>
          <Placeholder.Button xs={8} variant={ButtonTypes.PRIMARY} style={{ marginBottom: '5px', marginTop: '5px' }} />
          <Placeholder.Button xs={8} variant={ButtonTypes.SECONDARY} />
        </div>
      </div>
    </div>
  )
}

export default ReactPSUTeaserSkeleton
